import { useTranslation } from 'react-i18next';

import { RailSearchForm } from '@frontend/features/travel-services/components/RailSearchForm';
import { TravelServicesPage } from '@frontend/features/travel-services/components/TravelServicesPage';
import { useSearchFormKey } from '@frontend/features/travel-services/useSearchUrlState';

/** Buscador de trenes (vertical rail de Rutero). */
export const Rail = () => {
  const { t } = useTranslation();
  // Aplicar una búsqueda reciente remonta el buscador: si no, los campos
  // (que se llenan al montar) quedarían vacíos bajo los resultados nuevos.
  const formKey = useSearchFormKey();

  return (
    <TravelServicesPage
      title={t('common.nav.rail')}
      intro={t('travelServices.railIntro')}
    >
      <RailSearchForm key={formKey} />
    </TravelServicesPage>
  );
};

export default Rail;
